import React from 'react';
import { MultiCombobox } from '~/components/uie-fix/MultiCombobox';
import { useFilterField } from '../../hooks/useFilterField';
import { useStaticProps } from '../../context';

export const CampusFilter = () => {
  const campusFilter = useFilterField('campusId', 'PrimaryFilter');
  const { referenceData } = useStaticProps();
  const campuses = React.useMemo(() => referenceData.campuses ?? {}, [referenceData.campuses]);

  const shouldShowCampusFilter = Object.keys(campuses).length > 1;
  const sortedCampuses = React.useMemo(
    () =>
      Object.entries(campuses)
        .map(([id, { name }]) => ({ id, name }))
        .sort((a, b) => a.name.localeCompare(b.name)),
    [campuses]
  );

  if (!shouldShowCampusFilter) {
    return null;
  }

  return (
    <MultiCombobox
      value={campusFilter.value}
      aria-label="Campus"
      placeholder="Campus"
      onChange={(selectedItems) => campusFilter.setValue(selectedItems.filter((s) => !!s.trim()))}
      placeholderVariant="indicator"
    >
      {sortedCampuses.map((campus) => (
        <MultiCombobox.Option label={campus.name} value={campus.id} key={campus.id} />
      ))}
    </MultiCombobox>
  );
};
